import { SORT_ASC } from '@/constants/broker_metrics';
import type { SortDirection } from '@/types/main';
import ChevronDownIcon from './ChevronDownIcon';
import InfoCircleIcon from './InfoCircleIcon';

function SortableHeader<Column extends string>({
    label,
    column,
    align = 'right',
    padding = 'px-4 py-2',
    info,
    tooltipPosition = 'bottom',
    sortColumn,
    sortDirection,
    onSort,
}: Readonly<{
    label: string;
    column: Column;
    align?: 'left' | 'right';
    padding?: string;
    info?: string;
    tooltipPosition?: 'bottom' | 'left';
    sortColumn: Column;
    sortDirection: SortDirection;
    onSort: (column: Column) => void;
}>) {
    const active = sortColumn === column;
    let ariaSort: 'ascending' | 'descending' | 'none' = 'none';
    if (active) {
        ariaSort = sortDirection === SORT_ASC ? 'ascending' : 'descending';
    }

    return (
        <th
            scope='col'
            aria-sort={ariaSort}
            onClick={() => onSort(column)}
            className={`min-w-0 ${padding} cursor-pointer select-none text-xs font-medium leading-4 text-[#3A3A3A] hover:text-[#3A3A3A] ${
                align === 'right' ? 'text-right' : 'text-left'
            }`}>
            <span
                className={`inline-flex w-full min-w-0 items-center gap-0.5 whitespace-nowrap sm:gap-1 ${
                    align === 'right' ? 'justify-end' : ''
                }`}>
                {info && (
                    <button
                        type='button'
                        className={`tooltip inline-flex shrink-0 font-normal before:max-w-[14rem] before:whitespace-normal before:text-left ${
                            tooltipPosition === 'left' ? 'tooltip-left' : 'tooltip-bottom'
                        }`}
                        data-tip={info}
                        aria-label={`${label} info`}
                        onClick={(event) => event.stopPropagation()}>
                        <InfoCircleIcon />
                    </button>
                )}
                {label}
                <ChevronDownIcon className={active && sortDirection === SORT_ASC ? 'rotate-180' : ''} />
            </span>
        </th>
    );
}

export default SortableHeader;
